import TextCell from 'components/TextCell';
import type { ManagedFleet } from '../..';

interface SentinelTeamNameCellProps {
  rowData: ManagedFleet;
}

export default function SentinelTeamNameCell({
  rowData: { sentinelTeam },
}: SentinelTeamNameCellProps) {
  return <TextCell text={sentinelTeam?.name} />;
}
